/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkPlanView } from './workPlanView';
import { WorkPlanViewFactor } from './workPlanViewFactor';


/**
 * Project Work Plan View
 */
import { ValidateUtils } from 'app/shared/utils';

export class WorkPlanViewAssignments { 
    workPlanView?: WorkPlanView;
    /**
     * List of Action factors
     */
    factorHierarchy?: Array<WorkPlanViewFactor>;

    constructor(item?: Partial<WorkPlanViewAssignments>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            workPlanView: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.workPlanView : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            factorHierarchy: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.factorHierarchy : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: WorkPlanViewAssignments.isValid,
        };
    }

    static isValid(obj: WorkPlanViewAssignments): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = WorkPlanViewAssignments.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.workPlanView.isValid(item);
            result = result && validationObject.factorHierarchy.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

